import React from 'react'

export default function Title({title}) {
  return (
    <div className='section-title'>
      {title}
      <div/>
    </div>
  )
}

